import { render, staticRenderFns } from "./BillerSelection.vue?vue&type=template&id=52e07665"
import script from "./BillerSelection.vue?vue&type=script&lang=js"
export * from "./BillerSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports